import { useEffect } from 'react';
import { datadogInit } from '~/lib/datadog';

export default function useTrackingProviders() {
  useEffect(() => {
    datadogInit();
  }, []);
}
